import i18n, { I18nPaths } from '@/i18n';

export const getTextsForFilterSelect = (name: string, mode: string) => {
  const emptySpecific = `filter.filters.${name}.empty.${mode}` as I18nPaths;
  const placeholderSpecific = `filter.filters.${name}.placeholder.${mode}` as I18nPaths;
  const searchPlaceholderSpecific = `filter.filters.${name}.searchPlaceholder.${mode}` as I18nPaths;
  const searchEmptySpecific = `filter.filters.${name}.searchEmpty.${mode}` as I18nPaths;

  /**
   * Text when no entity exists yet
   */
  const empty = i18n.global.te(emptySpecific)
    ? i18n.global.t(emptySpecific)
    : i18n.global.t(`filter.filters.${name}.empty.default` as I18nPaths);

  /**
   * Placeholder for the select opener button when nothing is selected
   */
  const placeholder = i18n.global.te(placeholderSpecific)
    ? i18n.global.t(placeholderSpecific)
    : i18n.global.t(`filter.filters.${name}.placeholder.default` as I18nPaths);

  /**
   * Placeholder for the search input
   */
  const searchPlaceholder = i18n.global.te(searchPlaceholderSpecific)
    ? i18n.global.t(searchPlaceholderSpecific)
    : i18n.global.t(`filter.filters.${name}.searchPlaceholder.default` as I18nPaths);

  /**
   * Text when search has no results.
   *
   * Has a global default that doesn't mention the entity type or mode.
   */
  let searchEmpty = i18n.global.t('filter.defaults.searchEmpty');

  if (i18n.global.te(searchEmptySpecific)) {
    searchEmpty = i18n.global.t(searchEmptySpecific);
  } else if (i18n.global.te(`filter.filters.${name}.searchEmpty.default` as I18nPaths)) {
    searchEmpty = i18n.global.t(`filter.filters.${name}.searchEmpty.default` as I18nPaths);
  }

  return {
    empty,
    placeholder,
    searchPlaceholder,
    searchEmpty,
  };
};
